<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">群信息头像</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" :loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="primary" @click="editBannerDialog(-1)">创建</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            border
        >
          <el-table-column property="id" label="序号" v-if="checkColList.indexOf('序号') > -1"></el-table-column>
          <el-table-column property="createTime" label="创建时间" v-if="checkColList.indexOf('创建时间') > -1"></el-table-column>
          <el-table-column property="" label="头像" v-if="checkColList.indexOf('头像') > -1">
            <template #default="scope">
              <el-image style="height: 50px; cursor: pointer;" :src="scope.row.img" @click="showImg(scope.row.img)"></el-image>
            </template>
          </el-table-column>
          <el-table-column property="" label="性别" v-if="checkColList.indexOf('性别') > -1">
            <template #default="scope">
              {{scope.row.sex == 1?'男':scope.row.sex == 2?'女':''}}
            </template>
          </el-table-column>
          <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1">
            <template #default="scope">
              {{scope.row.state == 0?'待展示':scope.row.state == 1?'展示中':scope.row.state == 2?'已下架':''}}
            </template>
          </el-table-column>
          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1">
            <template #default="scope">
              <el-space wrap>
                <el-button size="small" @click="editBannerDialog(scope.$index,scope.row)" type="primary">编辑</el-button>
                <el-button size="small" v-loading="scope.row['updateLoading']" type="success" v-show="scope.row.state == 0 || scope.row.state == 2" @click="updateState(scope.$index, scope.row, 1)">上架</el-button>
                <el-button size="small" v-loading="scope.row['updateLoading']" type="warning" v-show="scope.row.state == 1" @click="updateState(scope.$index, scope.row, 2)">下架</el-button>
              </el-space>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import BtnGroup from '../../components/BtnGroup'
import { getSysHeadPageList, updateSysHeadState } from '../../api/url'
import {getFormData, postFormData} from '../../api/api'
import Dialog from "@/assets/js/dialog";
import HeadImgDialog from "./components/HeadImgDialog";
import ImgViewer from "@/assets/js/imageViewer";

export default {
  name: "SysHeadImg",
  components: { BtnGroup },
  data() {
    return {

      stateArray: [
        {label: '不限', value: -1},
        {label: '待展示', value: 0},
        {label: '展示中', value: 1},
        {label: '已下架', value: 2},
      ],
      state: -1,

      sexArray: [
        {label: '不限', value: -1},
        {label: '男', value: 1},
        {label: '女', value: 2},
      ],
      sex: -1,

      //刷新组
      colList: ['序号', '创建时间', '头像', '性别', '状态', '操作'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      searchLoading: false,
      listLoading: false,

    }
  },
  methods: {
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.state = -1;
      this.sex = -1;
      this.getPage(true);
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },


    showImg(img) {
      let imgList = []
      imgList.push(img)
      ImgViewer.open({
        imgList: imgList
      })
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['state'] = this.state;
      param['sex'] = this.sex;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getSysHeadPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch(() => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    editBannerDialog(idx, row) {
      let _title = '';
      let headForm = {}
      if (idx > -1) {
        _title = '编辑头像'
        headForm = Object.assign({}, row);
      }else {
        _title = '新建头像'
      }
      Dialog.open({
        title: _title,
        component: HeadImgDialog,
        data: {
          headForm: headForm,
          ids: idx,
          width: '500px'
        },
        confirm: (result) => {
            this.getPage()
        }
      })
    },

    updateState(idx, row, state) {
      this.pageDataList[idx]['updateLoading'] = true;
      let param = {};
      param['id'] = row.id;
      param['state'] = state;
      postFormData(updateSysHeadState, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          })
          // this.getPage()
          row.state = state
        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.pageDataList[idx]['updateLoading'] = false;
      }).catch(()=> {
        this.pageDataList[idx]['updateLoading'] = false;
      })
    }


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
